import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICliente, IUbicacionBase } from 'modelos/src';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { ClienteSelectorComponent } from '../../../../../componentes/selectores/cliente-selector/cliente-selector.component';

/** Filtros del mapa de alarmas que no entran en el panel flotante */
export interface IAlarmasFiltros {
  direccion: string;
  nombre: string;
  clientes: string[];
  zonas: string[];
}

export const FILTROS_ALARMAS_VACIOS: IAlarmasFiltros = {
  direccion: '',
  nombre: '',
  clientes: [],
  zonas: [],
};

export interface IFiltrosAlarmasModalData {
  filtros: IAlarmasFiltros;
  zonas: IUbicacionBase<'Alarmas'>[];
  /** Filtrado en vivo: cada cambio refiltra el mapa sin cerrar el modal */
  onLiveChange?: (filtros: IAlarmasFiltros) => void;
}

/**
 * Filtros del mapa de alarmas. Misma mecánica que
 * `filtros-luminarias-modal`: no-modal (sin backdrop, el mapa detrás queda
 * usable), se cierra sólo con la X, y emite en vivo por `onLiveChange`.
 */
@Component({
  selector: 'app-filtros-alarmas-modal',
  standalone: true,
  imports: [
    AuxiliaresModule,
    FormsModule,
    MatDialogModule,
    NgSelectModule,
    ClienteSelectorComponent,
    DragDropModule,
    NgStyle,
  ],
  templateUrl: './filtros-alarmas-modal.component.html',
  styleUrls: ['./filtros-alarmas-modal.component.scss'],
})
export class FiltrosAlarmasModalComponent {
  private data = inject<IFiltrosAlarmasModalData>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<FiltrosAlarmasModalComponent>>(MatDialogRef);

  public direccion = this.data?.filtros?.direccion ?? '';
  public nombre = this.data?.filtros?.nombre ?? '';
  public clientes: string[] = [...(this.data?.filtros?.clientes ?? [])];
  public zonasSeleccionadas: string[] = [...(this.data?.filtros?.zonas ?? [])];

  public zonas: IUbicacionBase<'Alarmas'>[] = this.data?.zonas ?? [];
  public clientesObjs: ICliente[] = [];

  private get valor(): IAlarmasFiltros {
    return {
      direccion: this.direccion,
      nombre: this.nombre,
      clientes: [...this.clientes],
      zonas: [...this.zonasSeleccionadas],
    };
  }

  public onCambio(): void {
    this.data?.onLiveChange?.(this.valor);
  }

  public limpiar(): void {
    this.direccion = '';
    this.nombre = '';
    this.clientes = [];
    this.zonasSeleccionadas = [];
    this.clientesObjs = [];
    this.onCambio();
  }

  public cerrar(): void {
    this.dialogRef.close(this.valor);
  }
}
